import React, { createContext, useState } from 'react';



export const ReportingContext = createContext();

export const ReportingProvider = ({ children }) => {
  const [activateRefresh, setActivateRefresh] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [types, setTypes] = useState(false);

  return (
    <ReportingContext.Provider value={{ 
      activateRefresh, setActivateRefresh, refresh, setRefresh, types, setTypes
    }}>
      {children}
    </ReportingContext.Provider>
  );
};